import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import type { AxiosInstance } from "axios";

let productionZonesApiPromise: Promise<AxiosInstance> | null = null;

const getProductionZonesApi = async (): Promise<AxiosInstance | null> => {
  if (productionZonesApiPromise !== null) return productionZonesApiPromise;
  productionZonesApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return productionZonesApiPromise;
};

export interface GetProductionZonesListProps {
  Nombre?: string;
  ZonaComercial?: string[];
  Activo?: boolean;
  "P.Pagina": number;
  "P.Records"?: number;
}

export interface CreateProductionZoneBody {
  nombre: string;
  zonaComercial: string;
}

export interface ProductionZoneDetailResponse {
  id: number;
  nombre: string;
  zonaComercial: string;
  activo: boolean;
}

export interface UpdateProductionZoneBody extends CreateProductionZoneBody {
  id: number;
  activo: boolean;
}

export const getProductionZonesList = async (
  props: GetProductionZonesListProps,
) => {
  const api = await getProductionZonesApi();
  if (!api) return;

  const response = await api.get(
    `/ZonasProductivas/all?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export const getProductionZone = async (id: number) => {
  const api = await getProductionZonesApi();
  if (!api) return;

  const response = await api.get(`/ZonasProductivas/${id}`);

  return response.data as ProductionZoneDetailResponse;
};

export const createProductionZone = async (
  body: CreateProductionZoneBody,
) => {
  const api = await getProductionZonesApi();
  if (!api) return;

  const response = await api.post(`/ZonasProductivas`, body);

  return response.data;
};

export const updateProductionZone = async (
  body: UpdateProductionZoneBody,
) => {
  const api = await getProductionZonesApi();
  if (!api) return;

  const response = await api.put(`/ZonasProductivas/${body.id}`, body);

  return response.data;
};
